export default __webpack_public_path__ + "static/media/relax.d7bc7c6d.jpeg";